import AlertPopup from "@/components/common/AlertPopupComponent.vue";
let vm = {};
export default {
  install(Vue, opts) {
    opts = opts || {};
    const alertPlugin = Vue.extend(AlertPopup);
    vm = new alertPlugin({
      data: opts
    }).$mount();

    document.body.appendChild(vm.$el);

    Vue.prototype.$alert = {
      open(title, buttonText) {
        vm.hasOpen = true;
        vm.title = title;
        vm.buttonText = buttonText ?? window.app.$t("common.comfirm");
      },

      openWithCallback(title, fn, buttonText) {
        vm.hasOpen = true;
        vm.title = title;
        vm.buttonText = buttonText ?? window.app.$t("common.comfirm");
        vm.fnOk = fn;
      }
    };
  }
};
